// extracted by mini-css-extract-plugin
export default {"cls1":"w1AKe3t2vZCfHh0Uw2K_","cls2":"Sqax7KdPwrdMdFEr3z5k w1AKe3t2vZCfHh0Uw2K_"};